import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {SpinnerLoaderService} from './spinner-loader.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SpinnerInterceptorService implements HttpInterceptor {
  excludeSpinnerFor = [
    environment.getAllDevices,
    environment.getConnectivityStatus,
    environment.getConnectivityKPIs,
    environment.updateUserStatus,
    environment.getWatchlist,
    environment.getDashboardKPIs
  ];

  constructor(private readonly spinnerLoader: SpinnerLoaderService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let showSpinner = true;
    this.excludeSpinnerFor.forEach((excludePath) => {
      if (req.url.includes(excludePath)) {
        showSpinner = false;
      }
    });
    if (showSpinner) {
      this.spinnerLoader.isLoading.next(showSpinner);
      this.spinnerLoader.isProgressBar.next(!showSpinner);
    }
    return next.handle(req).pipe(
      tap({next:
          (event) => {
            if (event instanceof HttpResponse) {
              this.spinnerLoader.isLoading.next(false);
              this.spinnerLoader.isProgressBar.next(false);
            }
          },
        error: () => {
          this.spinnerLoader.isLoading.next(false);
          this.spinnerLoader.isProgressBar.next(false);
        }
      })
    );
  }

}
